import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

import { NAMESPACE } from '@/config/i18n/i18n.constants.ts';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(
    resourcesToBackend(async (lng: string, ns: string) => {
      const mod = await import(`@/assets/locales/${lng}.ts`);
      const all = mod.default ?? {};
      return all[ns] ?? all[NAMESPACE] ?? all;
    }),
  )
  .init<never>({
    defaultNS: NAMESPACE,
    detection: {
      caches: ['localStorage', 'cookie'],
      order: ['localStorage', 'cookie', 'navigator'],
    },

    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    ns: [NAMESPACE],
    supportedLngs: ['en', 'de', 'fr'],
  });
